import { render } from "./ChucNang.vue?vue&type=template&id=6ed099f2&scoped=true"
import script from "./ChucNang.vue?vue&type=script&lang=js"
export * from "./ChucNang.vue?vue&type=script&lang=js"

import "./ChucNang.vue?vue&type=style&index=0&id=6ed099f2&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed099f2"]])

export default __exports__